import React, { useState, useMemo, useEffect } from "react"
// import Particles, { initParticlesEngine } from "@tsparticles/react";
// import { loadAll } from "@tsparticles/all";
import { GatsbyImage } from "gatsby-plugin-image";
import ContainerMax from "components/shared/ContainerMax"
import styled, { css } from "styled-components"
import { media } from "utils/Media"
import CountDown from "components/shared/CountDown";

const ContainerMaxStyled = styled(ContainerMax)`
  display: block;
  position: relative;
  overflow: hidden;

  ${props => props.$overlay && css`
    &:after {
      content: "";
      position: absolute;
      z-index: 2;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      background-image: linear-gradient(to right, rgba(50,55,65, .65), rgba(50,55,65, 0));
      display:none;
      
      @media ${media.md} {
        display:block;
      }
    }
  `}
  .mobileImage {
    @media ${media.sm} {
        display: none;
    }
  }
  .tabletImage {
    display: none;
    @media ${media.sm} { 
        display: block;
    }
    @media ${media.xl} { 
        display: none;
    }
  }
  .desktopImage {
    display: none;
    @media ${media.xl} { 
        display: block;
    }
  }
`

const ParticleWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  overflow: hidden;

  .particles-canvas {
    width: 100%;
    height: 100%;
    position: absolute;
  }
`

const TitleStrip = styled.div`
  background-color: ${props => props.theme.colors.secondary};
  padding: 1rem;
  height: 100%;
  position: relative;
  margin: -1px;
  h1 {
    color: white;
    text-align: center;
    margin: 0;
    padding: 0;
  }
`

export default function CountDownHero(props) {
  const [init, setInit] = useState(false);
  const {
    overlayTint,
    imageMobile,
    imageTablet,
    imageDesktop,
    title,
    countdownEndDate,
    countdownButton
  } = props.block

  const test = true

  // this should be run only once per application lifetime
  // useEffect(() => {
  //   initParticlesEngine(async (engine) => {
  //     // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
  //     // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
  //     // starting from v2 you can add only the features you need reducing the bundle size
  //     await loadAll(engine);
  //     //await loadFull(engine);
  //     // await loadSlim(engine);
  //     //await loadBasic(engine);
  //   }).then(() => {
  //     setInit(true);
  //   });
  // }, []);

  // const particlesLoaded = (container) => {
  //   console.log(container);
  // };

  const options = useMemo(
    () => ({
      particles: {
        number: {
          value: 800,
          density: {
            enable: true,
            valueArea: 800
          }
        },
        color: {
          value: "#ffffff"
        },
        shape: {
          type: "circle",
          stroke: {
            width: 0,
            color: "#000000"
          },
          polygon: {
            nbSides: 5
          },
          image: {
            src: "img/github.svg",
            width: 100,
            height: 100
          }
        },
        opacity: {
          value: { min: 0.3, max: 1 },
          random: true,
          animation: {
            enable: true,
            speed: .5,
            minimumValue: .1,
            sync: false
          }
        },
        size: {
          value: { min: 0, max: 2 },
          random: true,
          animation: {
            enable: false,
            speed: 4,
            minimumValue: 0,
            sync: false
          }
        },
        lineLinked: {
          enable: false,
          distance: 150,
          color: "#ffffff",
          opacity: 0.4,
          width: 1
        },
        move: {
          enable: true,
          speed: .5,
          direction: "none",
          random: true,
          straight: false,
          outMode: "out",
          bounce: false,
          attract: {
            enable: false,
            rotateX: 600,
            rotateY: 600
          }
        }
      },
      fullScreen: {
        enable: false
      },
      retinaDetect: true
  }));

  return (
    <ContainerMaxStyled maxWidth="1920" noPadding $overlay={overlayTint}>

      {/* <ParticleWrap>
        <Particles
          id="tsparticles"
          particlesLoaded={particlesLoaded}
          options={options}
          className="particles-canvas"
        />
      </ParticleWrap> */}

      {imageMobile !== null &&
        <GatsbyImage
          image={imageMobile.localFile.childImageSharp.gatsbyImageData}
          className="mobileImage"
          alt={imageMobile.altText} 
        />    
      }
      {imageTablet !== null &&
        <GatsbyImage
          image={imageTablet.localFile.childImageSharp.gatsbyImageData}
          className="tabletImage"
          alt={imageTablet.altText} 
        />    
      }
      {imageDesktop !== null &&
        <GatsbyImage
          image={imageDesktop.localFile.childImageSharp.gatsbyImageData}
          className="desktopImage"
          alt={imageDesktop.altText} 
        />    
      }
      {title && (
        <TitleStrip>
          <h1>{title}</h1>
        </TitleStrip>
      )}
      {test && (
        <CountDown value={countdownEndDate} button={countdownButton} />
      )}
    </ContainerMaxStyled>
  )
}